import { render, staticRenderFns } from "./TourDuration.vue?vue&type=template&id=34d0ecfc"
import script from "./TourDuration.vue?vue&type=script&lang=js"
export * from "./TourDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d0ecfc')) {
      api.createRecord('34d0ecfc', component.options)
    } else {
      api.reload('34d0ecfc', component.options)
    }
    module.hot.accept("./TourDuration.vue?vue&type=template&id=34d0ecfc", function () {
      api.rerender('34d0ecfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/TourDuration.vue"
export default component.exports